export default __webpack_public_path__ + "static/media/f.4662e319.svg";